module.exports = __webpack_public_path__ + "img/lunarToolbox.2538a354.webp";